import Axios, { AxiosInstance } from "axios";
import { KeycloakService } from "service/KeycloakService";
import { DateParser } from "util/DateParser";


export class ApiAxios {

  private static api?: ApiAxios = undefined;
  private readonly axios: AxiosInstance;

  public static get instance() {
    if (ApiAxios.api === undefined) {
      ApiAxios.api = new ApiAxios();
    }
    return ApiAxios.api.axios;
  }

  private constructor() {
    this.axios = Axios.create({
      baseURL: process.env.REACT_APP_API_HOST,
      timeout: 60*1000,
      // FIXME: Conversão automática de datas, cujo chaves
      //        atendam alguns critérios (exemplo, ter "data" no nome)
      transformResponse: [(data) => {
        try {
          return JSON.parse(data, DateParser.parse)
        } catch (SyntaxError) {
          return data;
        }
      }]
    });

    this.axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
    this.axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

    this.axios.interceptors.request.use(
      async config => {
        const keycloak = KeycloakService.instance.keycloak;
        if (config.headers === undefined) {
          config.headers = {};
        }
        config.headers.Authorization = 'Bearer ' + keycloak.token;
        return config;
      },
      error => Promise.reject(error),
    );
  }
}